export default {
  search: { id: 'search' },
  select: { id: 'select' },
  users: { id: 'users' },
  userGroups: { id: 'user_groups' },
  selectAll: { id: 'select_all' },
  noRelevantInputs: { id: 'no_results' },
  clearSelection: { id: 'clear_selection' },
}
